module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAIaGhgCZ/xVrmwhqnxZkmh1cjQxflghfkxJPgw5PgxdMfwpPhQZPgwJPgyJDbzM8YjUkAD0YDCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAACH5BAEAABwALAAAAAAgACAAAAWdICeOZGmeaGpu7Ka+K+nCMGCLNkCreZ/vJ59QBxwNh0XO5oh85VhPjYVJ5LVylytylmJNe5HWwyfinlgUhzAM7ZW77eGEhSGbZfGjZFMnnzcXVDkQS25BgoIoiImHi0eKT4WIFSwokgBaVC1dPplDV5ydGxlHWqGilzabHFWNqD2rNEcXWZFJRxSSdzuISSRUviWPwcJ+xMWYx8ooIQA7"


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadNE_S7.gif
// module id = w6fp
// module chunks = 50